var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 1.8335C5.9387 1.8335 1.83203 5.94016 1.83203 11.0002C1.83203 16.0602 5.9387 20.1668 10.9987 20.1668C16.0587 20.1668 20.1654 16.0602 20.1654 11.0002C20.1654 5.94016 16.0587 1.8335 10.9987 1.8335ZM11.9154 15.5835H10.082V10.0835H11.9154V15.5835ZM11.9154 8.25016H10.082V6.41683H11.9154V8.25016Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.1848cc5017858f1033b804df8738a582.svg";
export { ForwardRef as ReactComponent };